export default __webpack_public_path__ + "static/media/background-1440.05f97167.jpg";